import "./i18n";

import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { RemindersProvider } from "./context/RemindersContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <RemindersProvider>
        <App />
      </RemindersProvider>
    </AuthProvider>
  </BrowserRouter>
);
